module.exports = __webpack_public_path__ + "img/changebtn.4ca8f51f.svg";